import { toast } from 'sonner';
import { messageFor } from '@/api/errors';
import { useLogout, useSwitchTenant } from '@/api/queries/auth';
import { useSession } from '@/auth/use-session';
import { Button } from '@/components/ui/button';
import { AuthLayout } from './auth-layout';

/**
 * Module 2: a logged-in person who is in no organisation right now (removed or deactivated
 * from the one they used). One clear page instead of an empty app: open another organisation
 * they still belong to, or log out.
 */
export function NoOrganisationPage() {
  const session = useSession();
  const switchTenant = useSwitchTenant();
  const logout = useLogout();
  const others = session.tenants;
  return (
    <AuthLayout
      title="You are not in this organisation any more"
      description={
        others.length > 0
          ? 'Your access to the organisation you were using has ended. Open another one you belong to:'
          : 'Your account is not part of any organisation now. If this is a mistake, ask the organisation’s admin to invite you again.'
      }
    >
      <div className="grid gap-3">
        {others.map((t) => (
          <Button
            key={t.id}
            variant="outline"
            size="lg"
            className="w-full"
            disabled={switchTenant.isPending}
            onClick={() =>
              switchTenant.mutate(t.id, {
                onSuccess: () => window.location.assign('/home'),
                onError: (err) => toast.error(messageFor(err)),
              })
            }
          >
            Open {t.name}
          </Button>
        ))}
        <p className="text-sm text-muted-foreground">Logged in as {session.user.email}</p>
        <Button
          size="lg"
          className="w-full"
          disabled={logout.isPending}
          onClick={() =>
            logout.mutate(false, { onSettled: () => window.location.assign('/login') })
          }
        >
          Log out
        </Button>
      </div>
    </AuthLayout>
  );
}
